function Privacy() {
  return (
    <>
      <section class="py-8 bg-auto bg-image">
        <div class="container my-lg-8">
          <div class="row justify-content-center py-6">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-4 text-white fw-bold">
                  <span>Privacy Policy</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item lead">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active lead text-white"
                    aria-current="page"
                  >
                    Privacy
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-8">
        <div className="container">
          <h1 class="fw-bold lh-1">Privacy Policy</h1>
          <p className="lead lh-sm text-danger mb-3">
            Our privacy is very important to us. When you visit
            www.Microfinancebazar.com, we automatically collect and store a log
            file, which contains the following information about your visit:
          </p>

          <p className="lead mb-3 fs-4 text-dark lh-sm">
            <ul className="mb-3">
              <li>the date and time;</li>
              <li>the originating Internet Protocol (IP) address;</li>
              <li>
                the type of browser and operating system used (if provided by
                the browser);
              </li>
              <li>
                the URL of the referring page (if provided by the browser);
              </li>
              <li>the object requested;</li>
              <li>
                the number of bytes transferred to and from your computer;
              </li>
              <li>completion status of the request; and</li>
              <li>pages visited.</li>
              <li>Adhaar card number</li>
              <li>Registered Mobile number</li>
              <li> Bank Account details</li>
            </ul>
          </p>

          <p className="lead mb-3 fs-4 lh-sm">
            Microfinancebazar uses these log files to evaluate aggregate visitor
            usage so that we can optimize the content of this website and server
            performance to better meet your needs. In the event of a security
            incident, such data may be further refined manually to allow
            security specialists to identify Internet service providers and, in
            extreme cases, individuals causing a security breach.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Microfinancebazar reserves the right to disclose any information
            gathered from the log reports or from a form on its website to its
            agents or contractors, or when the disclosure is required by law or
            regulation. Microfinancebazar otherwise does not sell, lend, rent or
            otherwise provide this information to any third parties. This site
            has instituted security measures to protect the loss, misuse, and
            alteration of the information under our control.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Microfinancebazar.com contains links to other third-party websites.
            Microfinancebazar does not endorse, and is not responsible for, the
            privacy practices or the content of these websites.
          </p>
          <p className="lead mb-3 fs-4 lh-sm">
            Microfinancebazar reserves the right to modify or update this
            Privacy Policy or other terms and conditions of use of this site at
            any time. Any modifications or updates are effective upon posting to
            Microfinancebazar.in.
          </p>

          <p className="lead lh-sm text-danger mb-3">
            If you have questions concerning our privacy policy, please Contact
            Us.
          </p>
        </div>
      </section>
    </>
  );
}

export default Privacy;
